<template>
    <section class="quote">
        <h2>Get a Quote</h2>
        <form class="quote-form" @submit.prevent="submitQuoteRequest()">
            <div style="display: grid; gap: 2px">
                <label for="field-lob" style="font-size: 13px; height: 16px">Insurance Type</label>
                <div class="select">
                    <select id="field-lob" v-model="quoteForm.lob" name="field-lob">
                        <option
                            v-for="(option, index) in office.quoteOptions"
                            :key="index"
                            :value="option[1]"
                        >
                            {{ option[0] }}
                        </option>
                    </select>
                </div>
            </div>
            <button
                aria-label="start quote"
                class="btn btn-gaq"
                type="submit"
                style="height: 50px; margin-top: 18px"
            >
                Get Quote
            </button>
        </form>
    </section>
</template>

<script>
import { mapGetters } from 'vuex';
import QuoteHelpers from '@/mixins/quote';

export default {
    name: 'Quote',
    mixins: [QuoteHelpers],
    computed: {
        ...mapGetters(['office']),
    },
};
</script>

<style lang="scss" scoped>
.quote {
    background-color: $green;
    color: white;
    display: flex;
    padding: 3rem;
    flex-direction: column;
    margin: 0px;
    max-width: 600px;
    container-type: inline-size;
    border-radius: 12px;

    @include media('<md') {
        margin: 16px auto;
    }
    .quote-form {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 16px;
        margin-top: 1rem;

        @container (max-width: 350px) {
            grid-template-columns: 1fr;
            gap: 0px;
        }
        select {
            border-radius: 6px;
        }
    }

    h2 {
        color: white;
        margin-bottom: 0;
    }

    .quote-error {
        float: right;
        color: #fff;
    }
}
</style>
